import { Component, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { BoobleModalService } from 'booble-modal';
import { AuthenticationService } from 'src/app/shared/services';

@Component({
  selector: 'app-payment-sucess-inbound',
  templateUrl: './payment-sucess-inbound.component.html',
  styleUrls: ['./payment-sucess-inbound.component.scss'],
})
export class PaymentSucessInboundComponent implements OnInit {
  constructor(
    private modalService: BoobleModalService,
    private readonly accountService: AuthenticationService,
    private matIconRegistry: MatIconRegistry,
    private domSanitzer: DomSanitizer
  ) {
    this.matIconRegistry.addSvgIcon(
      'success',
      this.domSanitzer.bypassSecurityTrustResourceUrl('assets/icons/sucess.svg')
    );
  }

  get companyId() {
    return +this.accountService.getCompanyId();
  }

  ngOnInit() {}

  closeModal() {
    this.modalService.dismiss(null);
  }
}
